<section class="nxnback standard standard-{{ system }} flex" id="picker">
  <article class="content-wrap txt-center full-width">
    <h2>{{ 'PICKER.title' | translate }}</h2>
    <p class="margin-bottom-50">
      {{ 'CHOOSE.CONTENT' | translate }}
    </p>
    <form [formGroup]="pickerForm">
      <div formArrayName="basePick">
        <div
          *ngFor="let pickers of basePick.controls; let picker = index"
          class="choose-numbers picker-container font flex x-content-center margin-top-40 margin-bottom-40"
        >
          <a
            href="#picker"
            role="buttom"
            class="button redo gray gray-{{ system }} txt-uppercase underline-none relative-left"
            (click)="quickPick(picker)"
          >
            <i class="relative relative inline-block arrow-circle-{{ system }}"></i>
            {{ 'QUICKPICK' | translate }}
          </a>
          <!-- <div class="pick-container"> -->
          <div *ngFor="let b of pickers.controls; let i = index" class="picks">
            <input
              *ngIf="i < picksCount"
              type="number"
              [min]="extraPicksFrom"
              [max]="picksTo"
              class="basePicks basePicks-{{ system }} simple-num i-number"
              required
              [formControl]="b"
              (blur)="validateControl(picker, i)"
              (ngModelChange)="userInputControl(picker, i)"
            />
            <input
              *ngIf="i >= picksCount"
              type="number"
              [min]="picksFrom"
              [max]="extraPicksTo"
              class="extraPicks special-num-{{ system }} simple-num i-number"
              required
              [formControl]="b"
              (blur)="validateControl(picker, i)"
              (ngModelChange)="userInputControl(picker, i)"
            />
            <!-- </div> -->
          </div>
          <span *ngIf="picker < base" class="price-amount-{{ system }} pick-span">
            <ng-container *ngIf="currency == 'MXN'">MXN</ng-container>
            <ng-container *ngIf="currency == 'USD'">US</ng-container>
            <ng-container *ngIf="currency == 'BRL'">R</ng-container>
            <ng-container *ngIf="currency == 'AUD'">$</ng-container>
            <ng-container *ngIf="currency == 'PLN'">Z</ng-container>
            <ng-container *ngIf="currency == 'USD' || currency == 'CAD' || currency == 'BRL' || currency == 'MXN'">$</ng-container>
            <ng-container *ngIf="currency == 'EUR'">&euro;</ng-container>
            <ng-container *ngIf="currency == 'GBP'">&pound;</ng-container>
            <ng-container *ngIf="currency == 'AUD'">A</ng-container>
            <ng-container *ngIf="currency == 'PLN'">ł</ng-container>
            {{ ticketPrice | number: '1.2-2' }}
          </span>
          <ng-container *ngIf=""> </ng-container>
          <!-- <span *ngIf="picker >= base" class="price-free">{{ 'PICKER.free' | translate | uppercase }}</span> -->
        </div>
        <ng-container *ngIf="!pickerForm.valid || !enableLogin">
          <p class="margin-bottom-20">
            <ng-container *ngIf="('lang' | translate) === 'en'"> Invalid picks. Please check your numbers. </ng-container>
            <ng-container *ngIf="('lang' | translate) === 'es'"> Picks invalidos. Revise sus numeros. </ng-container>
            <ng-container *ngIf="('lang' | translate) === 'pt'"> Escolhas inválidas. Verifique seus números. </ng-container>
          </p>
        </ng-container>
      </div>
    </form>

    <div class="relative-left full-width cta-box cta-box-{{ system }} bg-whithe">
      <div class="relative-left lotto-promo-box">
        <img [src]="baseUrl + sys + '/' + prodId + '.png'" class="lotto-logo relative-left" alt="Mega Millions" />
        <div class="relative-left cta-lotto">
          <h3>
            <ng-container *ngIf="lotName === 'powerball'">
              {{ 'POWERBALL-DISCOUNT' | translate }}
            </ng-container>
            <ng-container *ngIf="lotName === 'megamillions'">
              {{ 'MEGAMILLIONS-DISCOUNT' | translate }}
            </ng-container>
            <ng-container *ngIf="lotName === 'cash4life'">
              {{ 'CASHLIFE-DISCOUNT' | translate }}
            </ng-container>
            <ng-container *ngIf="lotName === 'superenalotto'">
              {{ 'SUPERENALOTTO-DISCOUNT' | translate }}
            </ng-container>
          </h3>
          <span class="timer relative-left">
            <app-countdown></app-countdown>
          </span>
        </div>
      </div>
      <div class="relative-right cta-total-box txt-center">
        <p class="total total-{{ system }} special">
          TOTAL:
          <small>
            <ng-container *ngIf="currency == 'MXN'">MXN</ng-container>
            <ng-container *ngIf="currency == 'USD'">US</ng-container>
            <ng-container *ngIf="currency == 'BRL'">R</ng-container>
            <ng-container *ngIf="currency == 'AUD'">$</ng-container>
            <ng-container *ngIf="currency == 'PLN'">Z</ng-container>
          </small>
          <ng-container *ngIf="currency == 'USD' || currency == 'CAD' || currency == 'BRL' || currency == 'MXN'">$</ng-container>
          <ng-container *ngIf="currency == 'EUR'">&euro;</ng-container>
          <ng-container *ngIf="currency == 'GBP'">&pound;</ng-container>
          <ng-container *ngIf="currency == 'AUD'">A</ng-container>
          <ng-container *ngIf="currency == 'PLN'">ł</ng-container>

          <ng-container *ngIf="lottoName == 'cash4life'">
            {{ totalTicketPrice - totalTicketPrice * 0.5 | number: '1.2-2' }}
          </ng-container>

          <ng-container *ngIf="lottoName !== 'cash4life'">
            {{ totalTicketPrice - totalTicketPrice * 0.7 | number: '1.2-2' }}
          </ng-container>
        </p>
        <a
          id="inlineModal"
          class="button button-{{ system }} cta fancybox"
          [ngClass]="{ disabled: !enableLogin || basePick.status == 'INVALID' }"
          (click)="showLogin($event)"
        >
          {{ 'PlayNow' | translate }}
          <span *ngIf="system === 'ltk'">
            <img
              class="arrow-btn"
              [src]="'https://d3tmfelegj51yl.cloudfront.net/landings/discount-product/images/' + lottoName + '/' + system + '/es' + '/arrow-btn.svg'"
              alt="img-fluid"
            />
          </span>
        </a>
      </div>
    </div>
  </article>
  <div class="intro-form grow-2 login">
    <app-login *ngIf="upLogIn"></app-login>
  </div>
  <div *ngIf="upLogIn" class="block-shadow" (click)="hideLogin()"></div>
</section>
